// extracted by mini-css-extract-plugin
module.exports = {"button":"styled-button_button___64Z0","active":"styled-button_active__6_gtX","fadeIn":"styled-button_fadeIn__1a1Lt","fadeIn2":"styled-button_fadeIn2__a_Pcx"};